import React, { useState,useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBaseURL } from "../../../../env/stage";
import Button from "@atlaskit/button/new";
import {generateJWTTriggerKeyPair} from "../../../../redux/actions/integrationActions"
import ConfirmModal from "../../../../common/components/ConfirmModal";
const JWTWebhookTrigger = () => {
  const flow = useSelector((state) => state.integration.flow);
  const dispatch = useDispatch();
  const [privateKey, setPrivateKey] = useState(undefined);
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {  
    //console.log(flow.trigger.config)
    setPrivateKey(flow?.trigger?.config?.private_key)    
  }, [flow]);

  const webhookURL = `${getBaseURL()}/incoming/webhook/jwt`;
  const tokenExhange = `${getBaseURL()}/incoming/token`;
  const currentTime = Math.floor(Date.now() / 1000);
  const header = {
    alg: "RS256",
    typ: "JWT",
  };
  const jsonwebtoken = (
    <a href="https://www.npmjs.com/package/jsonwebtoken">jsonwebtoken</a>
  );
  const pyexample = <a href="https://pyjwt.readthedocs.io/en/stable/">PyJWT</a>;
  const payload = {
    iss: flow.clientKey,
    sub: flow.id,
    aud: "https://ihubprod.rixter.net/prod/incoming/token",
    iat: "current time in seconds, example current time is " + currentTime,
    exp:
      "plus 1200 current time in seconds, example current time+1200 is " +
      (currentTime + 1200),
  };


  const claims = {
    grant_type: "urn:ihub:jwt:bearer",
    assertion: "HEADER.PAYLOAD.SIGNATURE",
  };
  const generateKeyPair = () => {
    dispatch(generateJWTTriggerKeyPair(flow))
    setOpen(false)
  };

  return (
    <div className="ihub-edit-trigger">
      <p>
        Incoming webhooks serve as endpoints for external systems to initiate
        (run) this flow. To run this flow you must generate a JWT and exchange
        that for a Bearer token, which can be used to trigger this flow.
      </p>
      Do these steps:
      <ol>
        <li>
          Generate a signed JWT using any lib, example {jsonwebtoken} or
          {pyexample}.<br></br>
          <b>Header</b>
          <pre>
            <code>{JSON.stringify(header, null, 2)}</code>
          </pre>
          <br></br>
          <b>Payload</b>
          <pre>
            <code>{JSON.stringify(payload, null, 2)}</code>
          </pre>
          <b>Signing key</b>
          <pre>
            <code>
              {privateKey ? privateKey : "No key has been issued"}
              <br></br>
              <Button appearance="link" onClick={()=>setOpen(true)}>
                Click here to generate new key pair
              </Button>
            </code>
          </pre>
        </li>
        <li>
          Send a <span className="ihub-action-menu-list-method POST">POST</span> request with the body including the claims on this
          page to <b>{tokenExhange}</b>
          <br></br>
          <b>Body</b>
          <pre>
            <code>{JSON.stringify(claims, null, 2)}</code>
          </pre>
        </li>
        <li>
          Send a <span className="ihub-action-menu-list-method POST">POST</span> request with the body that the integration flow shall
          execute on to <b>{webhookURL}</b> with{" "}
          <b>Authentication: Bearer TOKEN_FROM_EXHANGE</b>
        </li>
      </ol>
      <ConfirmModal action="Generate New RSA Key" targetName={"for "+flow.name} targetId="213" isOpen={isOpen} onAction={generateKeyPair} onClose={()=>setOpen(false)} />
    </div>
  );
};

export default JWTWebhookTrigger;
